import { setStorage } from '@/utils/storage'
import {
  STORAGE_TRAIN_INFO,
  STORAGE_SELECT_SEAT_INFO,
  STORAGE_CURRENT_SUPPLIER_ID,
  STORAGE_DETAIL_REFRESH_FLAG,
  STORAGE_DETAIL_SEARCH_QUERY
} from '@/utils/train-storage'
import { cloneDeep } from 'lodash'
export default {
  setTrainList(state, payload) {
    state.trainListInfo = payload
    state.trainList = payload?.list || []
  },

  setTrainPre(state, payload) {
    // state.trainListInfo.is_login = payload.is_login;
    state.trainListInfo = { ...state.trainListInfo, ...payload }
  },
  /**
   * @description: 存储车次详情
   */
  setTrainDetail(state, payload) {
    const {
      from_station_name,
      to_station_name,
      train_code,
      start_time,
      arrive_time,
      ticket_data: original_ticket_data,
      travel_time_name,
      is_support_choose_seats,
      train_no,
      train_type_code,
      from_station_telecode,
      to_station_telecode,
      train_secrets,
      special_flag,
      is_start_station,
      is_end_station,
      pre_scrambl_flag,
      sale_msg,
      day_difference,
      transfer_ticket,
      transfer_station_name,
      transfer_city_id,
      transfer_station_city_name,
      transfer_stop_time,
      is_ticket_period,
      estimate_banner,
      refreshType,
      recommend_ticket,
      userGroup,
      noNeedStorage,
      package_info,
      noNeedSelectSeatInfoInit,
      ticket_left_urgent_num,
    } = payload || {};
    
    // 拆分出坐席页和填单页 权益信息
    // fe_can_show_scene: ['seat_detail', 'make_order']
    const ticket_data = original_ticket_data?.map(item => {
      const newItem = cloneDeep(item)
      if (newItem.service_info) {
        const seatDetailServiceInfoList = newItem.service_info?.serviceInfoList.filter(serviceItem => {
          return !serviceItem.fe_can_show_scene || serviceItem.fe_can_show_scene?.includes('seat_detail')
        })
        const makeOrderServiceInfoList = newItem.service_info?.serviceInfoList.filter(serviceItem => serviceItem.fe_can_show_scene?.includes('make_order'))
      
        newItem.service_info.serviceInfoList = seatDetailServiceInfoList
        newItem.service_info.makeOrderServiceInfoList = makeOrderServiceInfoList
      }
      return {
        ...newItem
      }
    })

    state.trainDetail = Object.assign({}, payload)

    const isTransfer = transfer_ticket && transfer_ticket.length > 0
    const isSupportChooseSeats = isTransfer ? transfer_ticket?.map(item => !!item?.is_support_choose_seats ?? false) : [!!is_support_choose_seats]
    const makeOrderInfo = {
      is_support_choose_seats: isSupportChooseSeats,
      train_no: train_no,
      train_code: train_code,
      train_type_code: train_type_code,
      from_station_telecode: from_station_telecode,
      from_station_name: from_station_name ?? '',
      to_station_name: to_station_name ?? '',
      to_station_telecode: to_station_telecode,
      start_time: start_time ?? '',
      train_secrets: train_secrets,
      special_flag: special_flag,
      transfer_station_name: transfer_station_name,
      transfer_city_id: transfer_city_id,
      transfer_stop_time: transfer_stop_time,
      transfer_station_city_name: transfer_station_city_name,
    }

    /**
     * trainInfo {Object} 火车信息
     */
    const trainInfo = {
      from_station_name: from_station_name,
      to_station_name: to_station_name,
      is_start_station: is_start_station,
      is_end_station: is_end_station,
      train_code: train_code ?? '',
      train_no: train_no ?? '',
      start_time: start_time ?? '',
      arrive_time: arrive_time ?? '',
      travel_time_name: travel_time_name ?? '',
      special_flag: special_flag,
      day_difference: day_difference,
      pre_scrambl_flag: pre_scrambl_flag,
      sale_msg: sale_msg,
      transfer_ticket: transfer_ticket,
      transfer_city_id: transfer_city_id,
      transfer_station_city_name: transfer_station_city_name,
      transfer_stop_time: transfer_stop_time,
      is_ticket_period: is_ticket_period,
      estimate_banner: estimate_banner,
      refreshType: refreshType,
      recommend_ticket: recommend_ticket,
      ticket_left_urgent_num,
    };
    const transferTicketData = transfer_ticket?.map(item => item.ticket_data)
    state.trainInfo = trainInfo
    state.ticketData = isTransfer ? transferTicketData : [ticket_data]
    state.packageInfo = package_info ?? {}

    state.recommendTicket = recommend_ticket?.length && recommend_ticket?.map(item => {
      item.title = `买${item.from_station_name}-${item.to_station_name}，`
      if (item.type == 1) {
        // 出发站多买
        item.tag = `多买${item.diff_station_num}站`
        item.title += `多付{{￥${item.diff_amount / 100}}}`
      } else if (item.type == 2) {
        // 到达站多买
        item.tag = `多买${item.diff_station_num}站`
        item.title += `多付{{￥${item.diff_amount / 100}}}`
        item.hightlight = '#FF6400'
      } else if (item.type == 3) {
        // 到达站少买
        item.tag = '上车补票'
        item.title += `上车后{{补${item.diff_station_num}站}}`
        item.hightlight = '#338FFF'
      }
      return item
    })

    /**
     * 车次详情默认选中 除无座外 价格最低的坐席，
     * 如果有且仅有无座，才选中无座
     */
    let selectSeatInfo = []
    if (refreshType === 'coupon' && !isTransfer) {
      // 新版填单页面，记录已经操作的选座逻辑
      selectSeatInfo[0] = ticket_data[0].find(
        item => item.seat_type === state.selectSeatInfo[0].seat_type
      );
    } 
    // else if(userGroup && isTransfer) {
    //   selectSeatInfo=[{},{}]
    // } 
    else if(isTransfer) {
      transferTicketData?.forEach(item =>{
        const tempTikcetData = item
        const arr = tempTikcetData?.filter(item => item.ticket_num !== '无票' && item.seat_type_name !== '无座')
        const noSeat = tempTikcetData?.find(item => item.seat_type_name === '无座')
        const minPrcieSeat = tempTikcetData?.reduce((pre, cur) => {
          return +pre.ticket_price <= +cur.ticket_price ? pre : cur;
        });

        let curSeat
        if (arr && arr.length) {
          // 选中价格最低的坐席
          curSeat = arr?.reduce((pre, cur) => {
            return +pre.ticket_price < +cur.ticket_price ? pre : cur
          })
        } else if (noSeat && noSeat.ticket_num !== '无票') {
          // 选中无座
          curSeat = noSeat
        } else {
          curSeat = minPrcieSeat
        }
        curSeat && selectSeatInfo.push(cloneDeep(curSeat))
      })
    } else {
      const arr = ticket_data?.filter(item => item.ticket_num !== '无票' && item.seat_type_name !== '无座')
      const noSeat = ticket_data?.find(item => item.seat_type_name === '无座')
      const minPrcieSeat = ticket_data?.reduce((pre, cur) => {
        return pre.ticket_price <= cur.ticket_price ? pre : cur;
      });
      let curSeat
      if(noNeedStorage) {
        // 多买少买逻辑
        const seatType = state.expectTicket?.recommend_ticket?.[0]?.seat_type
        curSeat = ticket_data?.find(item => item.seat_type === seatType)
        let rightInfo
        if(is_ticket_period){
          rightInfo = curSeat?.service_info?.offlineService ?? {}
        }
        else {
          rightInfo = curSeat?.service_info?.serviceInfoList?.find(right => right.type ===3) ?? {}
        }
        state.selectRightInfo = cloneDeep([rightInfo])
      } else {
        curSeat = {}
        if (arr && arr.length) {
          // 选中价格最低的坐席
          curSeat = arr?.reduce((pre, cur) => {
            return pre.ticket_price < cur.ticket_price ? pre : cur
          })
        } else if (noSeat && noSeat.ticket_num !== '无票') {
          // 选中无座
          curSeat = noSeat
        } else {
          curSeat = minPrcieSeat
        }
      }
      curSeat && selectSeatInfo.push(cloneDeep(curSeat))
    }
    if(!noNeedSelectSeatInfoInit) {
      state.selectSeatInfo = cloneDeep(selectSeatInfo)
    }
    state.makeOrderInfo = cloneDeep(makeOrderInfo)
    setStorage({ key: STORAGE_SELECT_SEAT_INFO, data: selectSeatInfo })
    if (state.trainDetail?.start_station_name && !noNeedStorage) {
      // 多买少买推荐车次数据不存到store里
      setStorage({ key: STORAGE_DETAIL_SEARCH_QUERY, data: state.trainDetail }) // 车次详情全量数据
    }
    // 存一下 给下单等页面使用
    setStorage({
      key: STORAGE_TRAIN_INFO,
      data: { trainInfo, makeOrderInfo, ticketData: ticket_data }
    })
  },

  /**
   * @method 存储选择的座位信息
   * @param state
   * @param payload
   */
  setSelectSeatInfo(state, payload) {
    state.selectSeatInfo = cloneDeep(payload)
    setStorage({ key: STORAGE_SELECT_SEAT_INFO, data: state.selectSeatInfo })
  },
  setSupplierId(state, payload) {
    console.log("payload=====>", payload)
    state.supplierId = payload
    setStorage({ key: STORAGE_CURRENT_SUPPLIER_ID, data: payload })
  },
  setTrainDetailRefreshFlag(state, payload) {
    state.trainDetailRefreshFlag = payload
    setStorage({ key: STORAGE_DETAIL_REFRESH_FLAG, data: payload })
  },
  setScrambleChooseTrains(state, payload) {
    state.scrambleChooseTrains = payload
  },
  setIsTransfer(state, payload) {
    state.isTransfer = payload
  },
  setShowRecommendTickets(state, payload) {
    state.showRecommendTickets = payload
  },
  setRecommendCardInfo(state, payload) {
    state.recommendCardInfo = payload
  },
  setExpectTicket(state, payload) {
    state.expectTicket = payload
  },
  // 坐席页选择权益卡片类型
  setSelectRightInfoType(state, payload) {
    state.selectRightInfoType = payload
  },
  // 权益卡片信息设置
  setSelectRightInfo(state, payload) {
    state.selectRightInfo = cloneDeep(payload)
  },
    // 选择加速包信息
  setSelectPackageItem(state, payload) {
    state.selectPackageItem = cloneDeep(payload);
  },
  setSelectPackageIndex(state, payload) {
    state.selectPackageIndex = payload
  },
  setSelectPackage(state, payload) {
    state.selectPackage = cloneDeep(payload);
  }
}
